// CareLogix™ — Connector Pack v1 shared client (AdminOne only).
// Token attached from carelogix_adminone_token; never used on public pages.
const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

function adminToken() {
  try { return localStorage.getItem("carelogix_adminone_token") || ""; } catch (_) { return ""; }
}

async function api(path, opts = {}) {
  const token = adminToken();
  const headers = { "Content-Type": "application/json", ...(opts.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;
  const res = await fetch(`${BACKEND}${path}`, { ...opts, headers });
  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    throw new Error(`${res.status} ${txt.slice(0, 240)}`);
  }
  return res.json();
}

export const connectorsApi = {
  status:   () => api("/api/adminone/connectors/status"),
  verify:   (name) => api("/api/adminone/connectors/verify", { method: "POST", body: JSON.stringify({ name }) }),
  disable:  (name) => api("/api/adminone/connectors/disable", { method: "POST", body: JSON.stringify({ name }) }),
  audit:    () => api("/api/adminone/connectors/audit"),
};

export const ehrApi = {
  log:     () => api("/api/adminone/ehr/ingestion-log"),
  audit:   () => api("/api/adminone/ehr/audit"),
};

export const africaApi = {
  nodes:   () => api("/api/adminone/africa-health/nodes"),
  audit:   () => api("/api/adminone/africa-health/audit"),
};

export const mobilityApi = {
  dispatches: () => api("/api/adminone/mobility/dispatches"),
  audit:      () => api("/api/adminone/mobility/audit"),
};

export const payoutsApi = {
  audit:    () => api("/api/adminone/payouts/audit"),
  ledger:   (id) => api(`/api/adminone/payouts/ledger/${encodeURIComponent(id)}`),
  retry:    (id, reason) => api("/api/adminone/payouts/retry",   { method: "POST", body: JSON.stringify({ settlement_id: id, reason: reason || null }) }),
  freeze:   (id, reason) => api("/api/adminone/payouts/freeze",  { method: "POST", body: JSON.stringify({ settlement_id: id, reason: reason || null }) }),
  release:  (id)         => api("/api/adminone/payouts/release", { method: "POST", body: JSON.stringify({ settlement_id: id }) }),
};

export const SHELL = {
  page:    { minHeight: "100vh", background: "#06120c", color: "#dfe3eb", padding: "32px 5vw 80px", fontFamily: "'Inter', system-ui, sans-serif" },
  h1:      { fontSize: "clamp(26px, 3.4vw, 38px)", fontWeight: 700, color: "#c5a059", margin: 0 },
  h2:      { fontSize: 14, fontWeight: 600, color: "#7AC860", textTransform: "uppercase", letterSpacing: "0.18em", margin: 0 },
  panel:   { background: "rgba(13,36,22,0.65)", border: "1px solid rgba(122,200,96,0.22)", borderRadius: 14, padding: 20, marginTop: 18 },
  table:   { width: "100%", borderCollapse: "collapse", fontSize: 13 },
  th:      { textAlign: "left", color: "#c5a059", fontSize: 11, letterSpacing: "0.14em", textTransform: "uppercase", padding: "6px 8px", borderBottom: "1px solid rgba(122,200,96,0.22)" },
  td:      { padding: "6px 8px", borderBottom: "1px solid rgba(122,200,96,0.08)" },
  badge:   (color = "#c5a059") => ({ display: "inline-block", padding: "3px 10px", border: `1px solid ${color}`, color, borderRadius: 999, fontSize: 11, letterSpacing: "0.14em", textTransform: "uppercase", fontWeight: 600 }),
  btn:     (primary = false) => ({ background: primary ? "#7AC860" : "transparent", color: primary ? "#06120c" : "#7AC860", border: "1px solid #7AC860", padding: "6px 12px", borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: "pointer", marginRight: 6 }),
  err:     { color: "#E5484D", fontSize: 13 },
  dim:     { color: "rgba(223,227,235,0.62)", fontSize: 12.5 },
};
